
<div [class]="divClasses" [class.dark]="dark">
  <ng-container *ngFor="let num of lines">
    <div [style.transform]="transform(num)" [style.animation-delay]="delay(num)"></div>
  </ng-container>
</div>